import "../pages.scss"
import { ProvinciasState } from '../../context/provincias/ProvinciasState';
import Datatable from "./provinciasTable/Datatable"

const ProvinciasPage = () => {
  return (
    <>
      <ProvinciasState>
        <Datatable />
      </ProvinciasState>

    </>
  )
}

export default ProvinciasPage